<h1 mat-dialog-title>Select Action</h1>
<div mat-dialog-content>
  <div class="flex flex-row justify-center items-center gap-6">
    <button mat-raised-button id="saveButton" class="m-1" (click)="handleAction('predictions')">
      <i class="fa-solid fa-magnifying-glass-chart mr-1"></i>	
      Show Benefits
    </button>
    <button *ngIf="data.crop !== ''" mat-raised-button id="saveButton" class="m-1"
      (click)="handleAction('economical')">
      <i class="fa-solid fa-hand-holding-dollar mr-1"></i>Show Economic Values
    </button>
    <div *ngIf="data.crop === ''" matTooltip="Select a crop to enable" matTooltipPosition="above">
      <button
          mat-raised-button
          class="m-1 gray-button"
          disabled>
        <i class="fa-solid fa-hand-holding-dollar mr-1"></i>Show Economic Values
      </button>
    </div>
    <button mat-raised-button id="saveButton" class="m-1" [matMenuTriggerFor]="benchmarkMenu">
      <i class="fa-solid fa-gear mr-1"></i>Show Benchmarking
    </button>
  </div>
</div>
<mat-menu #benchmarkMenu="matMenu">
  <div class="flex justify-center items-center">
    <mat-label><mat-icon>landscape</mat-icon></mat-label>
  </div>
  <button mat-menu-item (click)="handleAction('bareland')">Bareland</button>
  <button mat-menu-item (click)="handleAction('woodland')">Woodland</button>
  <button mat-menu-item (click)="handleAction('grassland')">Grassland</button>
  <button mat-menu-item (click)="handleAction('shrubland')">Shrubland</button>
  <button mat-menu-item (click)="handleAction('cropland')">Cropland</button>
</mat-menu>

<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</div>